export const types = {
  COMPANY_EQUIPMENTS_LOAD: "loadCompanyEquipments",
};
